
import { useState } from 'react';

interface EventHeroProps {
  heroImage: string;
  title: string;
  category: string;
  location: string;
  date: string;
  guests: number;
}

export default function EventHero({ heroImage, title, category, location, date, guests }: EventHeroProps) {
  return (
    <section className="relative w-full h-[70vh] min-h-[500px] overflow-hidden">
      <div className="absolute inset-0">
        <img src={heroImage} alt={title} className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-t from-stone-950/80 via-stone-950/30 to-stone-950/20"></div>
      </div>

      <div className="relative z-10 h-full flex flex-col justify-end pb-16 px-6 lg:px-12">
        <div className="max-w-5xl">
          <span className="inline-block px-4 py-1.5 bg-amber-500/20 backdrop-blur-sm border border-amber-400/30 text-amber-300 text-xs font-semibold tracking-wider uppercase rounded-full mb-5">
            {category}
          </span>
          <h1 className="text-4xl md:text-6xl font-display font-normal text-white mb-6 leading-tight">
            {title}
          </h1>
          <div className="flex flex-wrap items-center gap-6 text-white/70 text-sm">
            <span className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-map-pin-2-line text-amber-400"></i>
              </div>
              {location}
            </span>
            <span className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-calendar-line text-amber-400"></i>
              </div>
              {date}
            </span>
            <span className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-group-line text-amber-400"></i>
              </div>
              {guests} Guests
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
